var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85.48,
    height: 90.217,
    viewBox: "0 0 85.48 90.217",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M78.983,82.722V39.027L45.74,12.8,12.5,39.027V82.722Zm9.5,4.749a4.749,4.749,0,0,1-4.749,4.749H7.749A4.749,4.749,0,0,1,3,87.471V36.724A4.749,4.749,0,0,1,4.8,33L42.8,3.026a4.749,4.749,0,0,1,5.889,0L86.676,32.991a4.749,4.749,0,0,1,1.8,3.733V87.471ZM22,49.479h9.5a14.247,14.247,0,1,0,28.493,0h9.5a23.745,23.745,0,1,1-47.489,0Z",
    transform: "translate(-3 -2.003)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon-1.bcbc73f304f570a4995cebb0f95ab38c.svg";
export { ForwardRef as ReactComponent };